<template>
<div
    v-if="sign_in_options != null"
>
    <div
        v-if="sign_in_options.method_2fa == 'setup-totp'"
    >
        <p>You must setup two factor authentication before you can sign in.</p>
        <p>Use the QR code to add RedChirp to Google Authenticator</p>

        <div
            style="text-align: center"
        >
            <img :src="sign_in_options.totp_setup_qr_code.image_url"/>
        </div>

        <div style="text-align: center; margin-bottom: 15px; margin-top: -15px;">
            <code>{{sign_in_options.totp_setup_secret}}</code>
        </div>

            <p>Then enter the one time password (six digit code) produced.  This is used to confirm that your authenticator is properly configured</p>

            <v-text-field
                label="Enter one time password"
                :value="value"
                v-on:input="$emit('input', $event);"
                autocomplete="off"
                :hint="hint_totp"
                persistent-hint
            />
    </div>

    <div
        v-if="sign_in_options.method_2fa == 'totp'"
    >
        <v-text-field
            label="Enter one time password"
            :value="value"
            v-on:input="$emit('input', $event);"
            autocomplete="off"
        />
    </div>

</div>
</template>

<script>
export default {

    props: {
        username: {
            type: String,
            default: function() { return null; }
        },

        value: {
            type: String,
            default: function() { return null; }
        },

        is_valid: {
            type: Boolean,
            default: function() { return false; }
        },

        totp_setup_qr_code: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            sign_in_options: null,
            hint_totp: null,
        }
    },

    methods: {
        validateOTP()
        {
            if ( this.sign_in_options == null )
            {
                this.$emit('update:is_valid', true);
                return;
            }
            else if ( this.sign_in_options.method_2fa == 'setup-totp' )
            {
                this.validateTOTPSetup();
                return;
            }
            else if ( this.sign_in_options.method_2fa == 'totp' )
            {
                this.validateTOTP();
                return;
            }
        },

        otpLength()
        {
            return (this.value ?? '').replace(/\D/g, "").length;
        },

        validateTOTPSetup()
        {
            let is_valid_by_length = this.otpLength() == 6;

            if ( !is_valid_by_length )
            {
                this.hint_totp = null;
                this.$emit('update:is_valid', false);
                return;
            }

            this.$rc.rest(
                'PUT: /api/v1/auth/2fa/totp/could-enable-by-username',
            
                {
                    'username': this.username,
                    'qr_code_id': this.sign_in_options.totp_setup_qr_code.qr_code_id,
                    'otp' : this.value,
                },

                (data) => {
                    this.$emit('update:is_valid', data.success);
                    this.hint_totp = data.success ? null : 'The one time password you have entered is incorrect';
                },
            
                () => {
                    this.$emit('update:is_valid', false);
                },
            );
        },

        validateTOTP()
        {
            let is_valid = this.otpLength() == 6;
            this.$emit('update:is_valid', is_valid);
            return is_valid;
        },
    },

    watch: {
        username(new_value, old_value) {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/auth/get-sign-in-options',
            
                'params' : {
                        'username': new_value,
                    },
            
                'on_success': (data) => {
                        this.sign_in_options = data;
                        this.validateOTP();

                        if ( this.sign_in_options.totp_setup_required )
                        {
                            this.$emit('update:is_valid', false);
                        }
                        else
                        {
                            this.$emit('update:is_valid', true);
                        }

                        this.$emit('update:totp_setup_qr_code', this.$rc.getDeep(this.sign_in_options, 'totp_setup_qr_code/qr_code_id'));
                    },
            
                'on_error': () => { this.sign_in_options = null; },
            });
        },

        value(new_value, old_value)
        {
            this.validateOTP();
        },
    },
}
</script>

<style lang="scss" scoped>

</style>